// IE 2026 10 13 / ODOO-5800 (Igor, dev02, M03 Marketing plan · CF, вкладка ДЖЕРЕЛА): форма строки («Рядок[N] …», дочерний widget-row) закрывалась сама.
// Причина: фоновый опрос авто-пересчёта — смена cascade_stamp → cascade_state_refresh → updateDoc (только updates-бейдж) → WidgetAttrs.content_Changed()
// без аргументов → close_childrenWidgets(widget-row, widget-row-viewParams); второй путь — финиш прогона → updateRelatedWidgets → select → тот же content_Changed.
// Правило: обновление, пришедшее от фонового опроса (маркер _keepRowForms запроса), открытые формы строк НЕ закрывает; действие пользователя — закрывает, как раньше.
// Флаг fe.ux.pollKeepsRowForm (дефолт ВКЛ); выкл — как было. Юнит tests/unit/rowFormGate.test.mjs
export const POLL_KEEPS_ROW_FORM_FLAG = 'fe.ux.pollKeepsRowForm'   // IE 2026 10 13 / ODOO-5800

// маркер запроса фонового обновления (ставится только на путях опроса; ответ бэка наследует его в executeWidgetMethod)
export const KEEP_ROW_FORMS_MARK = '_keepRowForms'   // IE 2026 10 13 / ODOO-5800

export function pollKeepsRowForm_on(setting) {   // IE 2026 10 13 / ODOO-5800: чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(POLL_KEEPS_ROW_FORM_FLAG, true) !== false : true } catch (e) { return true }
}

// опции content_Changed по команде (ответу бэка / действию): фоновое — { keepRowForms: true }, иначе null
export function rowForm_contentOpts(action) {   // IE 2026 10 13 / ODOO-5800
    return action && typeof action === 'object' && action[KEEP_ROW_FORMS_MARK] === true ? { keepRowForms: true } : null
}

// закрывать ли открытые формы строк при content_Changed виджета: opts — опции content_Changed, flagOn — значение флага
export function rowForm_closeOnContentChange(opts, flagOn) {   // IE 2026 10 13 / ODOO-5800
    if (flagOn === false) return true
    return !(opts && opts.keepRowForms === true)
}

// IE 2026 10 13 / ODOO-5800 (бот dev02 fe-2026-10-13-15, «Рядок[2] … source_segments» вкладки SOURCES): форма строки не закрывалась, но каждые ~10 с на 0,5 с
// перецеплялась на «Рядок[20] _doc.AttrTabGrid-params». Путь (замер стеками): опрос → cascade_state_refresh → updateDoc (маркер) → WidgetAttrs.content_Changed
// рассылает content_Changed гридам → AttrGrid.content_Changed_afterTimeout → set_itemsSource / selRestore_apply → selectionChanged (программный) → таймер
// selectionChanged грида видит у формы строки чужой iroot → widget_open «Open line» своей строкой (грид скрытой вкладки PARAMS — тоже) → reload формы.
// Правило: смена выделения, пришедшая из фонового обновления (hold — перестройка грида внутри рассылки с маркером), и не выбор пользователя форму строки
// не перецепляет и не перерисовывает (флаг fe.ux.pollKeepsRowForm). Грид, которого нет на экране (скрытая вкладка, нулевой размер), форму строки не перецепляет
// никогда — пользователь его не видит (флаг fe.ux.rowFormSkipInternal, дефолт ВКЛ)
export const ROW_FORM_SKIP_INTERNAL_FLAG = 'fe.ux.rowFormSkipInternal'   // IE 2026 10 13 / ODOO-5800

export function rowFormSkipInternal_on(setting) {   // IE 2026 10 13 / ODOO-5800: чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting === 'function' ? setting(ROW_FORM_SKIP_INTERNAL_FLAG, true) !== false : true } catch (e) { return true }
}

// при планировании таймера selectionChanged: пропустить ли перецепку формы строки как фоновую.
// hold — смена выделения идёт внутри перестройки грида фоновым обновлением; user — выбор пользователя (событие ввода на гриде);
// pendingFree — ждущий таймер этого грида нёс НЕфоновую смену (её перецепку фоновая перестройка не отменяет); flagOn — fe.ux.pollKeepsRowForm
export function rowForm_holdRetarget({ hold = false, user = false, pendingFree = false, flagOn = true } = {}) {   // IE 2026 10 13 / ODOO-5800
    if (flagOn === false) return false
    return hold === true && !user && !pendingFree
}

// грид не на экране: нет хоста или нулевой размер (скрытая вкладка / display:none у предка)
export function rowForm_gridHidden(host) {   // IE 2026 10 13 / ODOO-5800
    if (!host) return true
    return !(host.offsetWidth || host.offsetHeight)
}

// при срабатывании таймера selectionChanged: причина НЕ трогать открытую форму строки ('' — трогать как раньше)
export function rowForm_retargetSkip({ held = false, hidden = false, skipInternalOn = true } = {}) {   // IE 2026 10 13 / ODOO-5800
    if (held) return 'background'
    if (hidden && skipInternalOn !== false) return 'hidden'
    return ''
}
